export default "__VITE_ASSET__BCq5V3kG__"